import { Component, ViewChild } from '@angular/core'
import { NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase } from '@ng-bootstrap/ng-bootstrap'

import { BaseComponent, FeatureType } from '../../shared'
import { LeadershipTeamVisitsDashboardComponent } from './leadership-team-visits-dashboard.component'
import { LeadershipTeamVisitsListComponent } from './leadership-team-visits-list.component'

@Component({
    selector: 'app-leadership-team-visits',
    templateUrl: './leadership-team-visits.component.html',
    standalone: true,
    imports: [
        NgbNav,
        NgbNavItem,
        NgbNavItemRole,
        NgbNavLink,
        NgbNavLinkBase,
        LeadershipTeamVisitsDashboardComponent,
        LeadershipTeamVisitsListComponent,
    ],
})
export class LeadershipTeamVisitsComponent extends BaseComponent {
    @ViewChild(LeadershipTeamVisitsDashboardComponent)
    dashboard?: LeadershipTeamVisitsDashboardComponent

    @ViewChild(LeadershipTeamVisitsListComponent)
    list?: LeadershipTeamVisitsListComponent

    activeTab = 0

    constructor() {
        super()
        this.activeTab = this.canViewDashboard ? 0 : 1
        this.initialLoadingComplete()
    }

    tabChanged() {
        if (this.isDashboardTab) {
            this.dashboard?.refresh()
        }
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'))
        }, 50)
    }

    onAddForJob(event: { jobId: string; jobName: string }) {
        void this.list?.openAddForJob(event.jobId, event.jobName)?.then(() => {
            this.dashboard?.refresh()
        })
    }

    get canViewDashboard() {
        return this.services.authentication.hasFeature([FeatureType.OperationsLeadershipTeamVisitsDashboardView])
    }

    get isDashboardTab() {
        return Number(this.activeTab) === 0
    }

    get isRecordsTab() {
        return Number(this.activeTab) === 1
    }
}
